export default [
  {
    path: '/users',
    name: 'settings-users',
    component: () => import('@/views/admin/user/UserList.vue')
  },
  {
    path: '/users/user/new-user',
    name: 'settings-users-newUser',
    component: () => import('@/views/admin/user/User.vue')
  },
  {
    path: '/users/user/:sub',
    name: 'settings-users-edit',
    component: () => import('@/views/admin/user/User.vue')
  }
]
